import IconCrownSolid from '@/assets/icons/font_awesome/crown-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_transfer_ownership_proposal_create } from '@/state/workspace/ownership/remote_workspace_transfer_ownership_proposal_create';
import { RequestWorkspaceUserOwnershipTransferCreate } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/_requests/request_workspace_transfer_ownership_create';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useTranslation } from 'react-i18next';
import { TransferOwnershipToastActions } from './WSTransferOwnershipToastActions';

interface Props {
  item: DTO__workspace_user;
}

export function WSButtonWorkspaceUserTransferOwnershipCreate({ item }: Props) {
  const { t } = useTranslation([ENUM__i18n_namespace.BASE_UI, ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE]);

  const dispatch = use_dispatch();
  const { toast, dismiss } = useToast();

  const { workspace_current, current_workspace_user, transfer_ownership_proposals_map } = use_slice_workspace([
    'workspace_current',
    'current_workspace_user',
    'transfer_ownership_proposals_map',
  ]);
  const transfer_ownership_proposal_workspace_current = Array.from(transfer_ownership_proposals_map.values()).find(
    i => i.workspace_id === workspace_current._id,
  );

  const tooltip_title = t(i18n_page_settings_workspace.tabs.users.shared.table.users.button.transfer_ownership.tooltip);

  function onClick() {
    const toast_data = toast({
      title: t(i18n_base_ui.toasts.transfer_ownership_create.title),
      description: (
        <span className="flex flex-col">
          {t(i18n_base_ui.toasts.transfer_ownership_create.description)} <span className="text-sm font-bold">{workspace_current.name}</span>
        </span>
      ),
      duration: Infinity,
      action: (
        <TransferOwnershipToastActions
          workspaceName={workspace_current.name}
          onConfirm={async () => {
            dismiss(toast_data.id);
            let request = new RequestWorkspaceUserOwnershipTransferCreate();
            request.workspace_id = item.workspace_id;
            request.workspace_user_id = item._id;

            await dispatch(remote_workspace_transfer_ownership_proposal_create(request));
          }}
          onCancel={() => {
            dismiss(toast_data.id);
          }}
        />
      ),
    });
  }

  if (workspace_current.user_id_owner !== current_workspace_user.user_id) return null;
  if (current_workspace_user.user_id === item.user_id) return null;
  if (transfer_ownership_proposal_workspace_current) return null;

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        iconClassNameBase="text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        Icon={IconCrownSolid}
        onClick={onClick}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
